import React from 'react';

interface StatCardProps {
    title: string;
    value: string;
    icon: React.ReactNode;
    change: string;
    changeColor: 'text-green-500' | 'text-red-500';
}

export const StatCard: React.FC<StatCardProps> = ({ title, value, icon, change, changeColor }) => {
    return (
        <div className="bg-white p-6 rounded-lg shadow-sm flex items-center justify-between">
            <div>
                <p className="text-sm font-medium text-gray-500">{title}</p>
                <p className="text-3xl font-bold text-gray-800 mt-1">{value}</p>
                <p className={`text-xs mt-2 ${changeColor}`}>{change} vs última semana</p>
            </div>
            <div className="bg-blue-100 text-blue-600 p-3 rounded-full">
                {icon}
            </div>
        </div>
    );
};